module.exports = __webpack_public_path__ + "static/media/Kanit-Medium.79d3ce8b.ttf";